// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel {
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #f5f7fa, #DBDCDD);
  margin: 10px;
}

td, th {
  border: 1px solid #ddd;
  padding: 8px;
  font-size: 10px;
}

.center-align {
  display: flex;
  justify-content: center;
  align-items: center;
}

:host ::ng-deep .p-tabview-nav li a {
  text-decoration: none;
}

:host ::ng-deep .custom-tabview .p-tabview-nav {
  justify-content: left;
  gap: 0px;
  display: inline-flex;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  background-color: linear-gradient(135deg, #f5f7fa, #DBDCDD);
}

:host ::ng-deep .p-inputswitch {
  width: 35px;
  height: 20px;
}

:host ::ng-deep .p-inputswitch-slider {
  width: 45px;
  height: 30px;
}

:host ::ng-deep .p-dropdown .p-dropdown-label {
  width: 100px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/users/users.component.scss"],"names":[],"mappings":"AACA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,qDAAA;EACA,YAAA;AAAF;;AAUC;EACC,sBAAA;EACA,YAAA;EACA,eAAA;AAPF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,qBAAA;AAPF;;AAUA;EACE,qBAAA;EACA,QAAA;EACA,oBAAA;EACA,yCAAA;EACA,2DAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;AAPF;;AAUA;EACE,uBAAA;AAPF","sourcesContent":["\n.panel {\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 6px 12px rgba(0,0,0,0.1);\n  background: linear-gradient(135deg, #f5f7fa, #DBDCDD);\n  margin: 10px;\n}\n\n// tr:hover {\n//   // background-color: #007ad9;\n//   // color: white;\n//   // a{\n//   //   color: white;\n//   // }\n// }\n td,  th {\n  border: 1px solid #ddd;\n  padding: 8px;\n  font-size: 10px;\n}\n\n.center-align {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n:host ::ng-deep .p-tabview-nav li a {\n  text-decoration: none;  \n}\n\n:host ::ng-deep .custom-tabview .p-tabview-nav {\n  justify-content: left;\n  gap: 0px;\n  display: inline-flex;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\n  background-color: linear-gradient(135deg, #f5f7fa, #DBDCDD)\n}\n\n:host ::ng-deep .p-inputswitch {\n  width: 35px;\n  height: 20px;\n}\n\n:host ::ng-deep .p-inputswitch-slider {\n  width: 45px;\n  height: 30px;\n}\n\n:host ::ng-deep .p-dropdown .p-dropdown-label {\n  width: 100px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
